/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import './Tour.css';
import Tour, { TourStep } from './Tour';

// Shown once (per the 'tourCloseHintSeen' preference, managed by MonsterContainer) when the user closes
// the LAST tour surface — a tour they didn't return to the selector from, or the tour selector itself.
// A single-step tour that highlights the #startTour button so they know how to get back to the tours.
const HINT_STEP: TourStep[] = [{
  highlightElement: '#startTour',
  title: 'Tours',
  scrollIntoView: true,
  description: (<div>You can take a guided tour at any time by clicking this button.</div>),
  position: 'bottom',
}];

interface ResumeHintProps {
  isOpen: boolean;
  onClose: () => void;
}

const ResumeHint: React.FC<ResumeHintProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }
  // No tourId, so this doesn't record progress; the single step is the last step, so it shows 'Done!'.
  return <Tour steps={HINT_STEP} currentStepIndex={0} setCurrentStepIndex={() => {}} onClose={() => onClose()} />;
};

export default ResumeHint;
